import React, { useState } from 'react'
import './NavBar.css'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'

function NavBar(props) {
  const { style } = props

  const cssStyle = {
    '--button-background-color': `${style.secondaryColor}`,
    '--button-color': `${style.primaryColor}`,
  }

  const { iframe, applicationDone } = props

  const [modal, setModal] = useState(false)

  const toggle = () => {
    setModal(!modal)
  }

  const handleForceClose = () => {
    toggle()
    closeIframe()
  }

  const handleClickClose = () => {
    if (applicationDone) {
      closeIframe()
    } else {
      toggle()
    }
  }

  const closeIframe = () => {
    window.parent.postMessage('closeIframe', '*')
  }

  return (
    <>
      <div className="navbar-component" style={cssStyle}>
        <div className="navbar area">
          <a
            className="logo-div"
            href="https://www.hollo.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/logo_hollo.png"
              className="brand-hollo"
              alt="hollo logo"
            />
          </a>
          {props.url ? (
            <div className="brand-by-hollo">
              <img src={props.url} className="brand-client" alt="hollo logo" />
            </div>
          ) : (
            ''
          )}
          <div className="toggle-div">
            <div className="toggle-button-placeholder">
              {iframe && (
                <a
                  href="#!"
                  className="close-iframe"
                  onClick={handleClickClose}
                >
                  <i className="" aria-hidden="true" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Arrêter la candidature</ModalHeader>
        <ModalBody>
          Votre candidature n'est pas encore terminée mais presque, souhaitez
          vous tout de même fermer la fenêtre ?
        </ModalBody>
        <ModalFooter>
          <Button
            color="link"
            style={{ color: style.secondaryColor }}
            onClick={toggle}
          >
            Reprendre
          </Button>
          <Button
            style={{ backgroundColor: style.secondaryColor }}
            onClick={handleForceClose}
          >
            Fermer
          </Button>{' '}
        </ModalFooter>
      </Modal>
    </>
  )
}

export default NavBar
